<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="check-circle">
      <path
        id="Icon"
        d="M5.49967 8.50004L7.49967 10.5L11.4997 6.50004M15.1663 8.50004C15.1663 12.1819 12.1816 15.1667 8.49967 15.1667C4.81778 15.1667 1.83301 12.1819 1.83301 8.50004C1.83301 4.81814 4.81778 1.83337 8.49967 1.83337C12.1816 1.83337 15.1663 4.81814 15.1663 8.50004Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
